export const CONTAINER_2XL = '1440px';
